var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "margin_left_sm margin_bottom_lg" },
      _vm._l(_vm.filterData, function(item, index) {
        return _c(
          "button",
          {
            staticClass: "tab-button",
            class: { "is-active": _vm.activeIndex === index },
            on: {
              click: function($event) {
                return _vm.change(item.category, index)
              }
            }
          },
          [_vm._v(_vm._s(item.name))]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "g-row g-row--space_xl" },
      _vm._l(_vm.renderArray, function(item) {
        return _c(
          "div",
          {
            staticClass:
              "g-cell g-cols g-cols--12 g-cols--6-md g-cols--4-lg margin_vertical_xl padding_horizontal_lg"
          },
          [
            _c(
              "a",
              {
                staticClass: "portfolio bgi-basic display_block",
                class: { animation: _vm.animate },
                attrs: { href: item.link, target: "_blank" }
              },
              [
                _c("span", { staticClass: "image-mask" }),
                _c("img", {
                  staticClass: "img-basic",
                  attrs: { src: item.img }
                }),
                _c("div", { staticClass: "portfolio-hover" }, [
                  _c("div", {
                    staticClass: "wysiwyg wysiwyg--white",
                    domProps: { innerHTML: _vm._s(item.content) }
                  })
                ]),
                _c(
                  "p",
                  {
                    staticClass:
                      "text_center text-hover fs_md fs_lg-lg color_white font-weight_bold z-index_2 position_relative"
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b975033", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b975033","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/UiTabs/UiTabs.vue
// module id = 71
// module chunks = 0